import React from 'react';
import styled from 'styled-components';

import Wrapper from './Wrapper';
import { HERO_IMAGE_URL, FOOTER_TEXT, TITLE, TAG_LINE, PRODUCTS, DOWNLOAD_URL } from './data';

const Container = styled.div`
  width: 80%;
  margin: auto;
  margin-top: 30px;
  padding-top: 30px;
  text-align: center;
  @media (max-width: 600px) {
    width: 100%;
  }
  @media (max-width: 1024) {
    width: 100%;
  }
`;

export default () => (
  <Container>
    <Wrapper
      heroImageURL={HERO_IMAGE_URL}
      footerText={FOOTER_TEXT}
      title={TITLE}
      tagLine={TAG_LINE}
      downloadURL={DOWNLOAD_URL}
      products={PRODUCTS}
    />
  </Container>
);
